{
  "accessibilityLink": "Accessibility Statement",
  "accessibilityPage": "Accessibility Statement",
  "addComment": "Write a comment",
  "addCommentAndVote": "Vote and write a comment",
  "addedFavorites": "Hearing added to favorites.",
  "addFavorites": "Add to favorites",
  "addGeojson": "Add geojson as a file",
  "addGeojsonInfo": "Note that the GeoJSON format uses the wgs84 coordinate system. Save only one area boundary to the file.",
  "addOption": "Add a choice option",
  "addProcess": "Add new phase",
  "addSection": "Add section",
  "additionalInfo": "Additional info",
  "adminFilterSelectorLabel": "Filter hearings",
  "adminCommentMessage": "You are logged in as an administrator. Your name and organization will be displayed with your comment",
  "all": "All",
  "allHearings": "All hearings",
  "alreadyFavorite": "The hearing is already in favorites.",
  "alreadyVoted": "You have already voted for this comment.",
  "alreadyFlagged": "This comment is already flagged.",
  "anonymous": "Anonymous",
  "APICallFailed": "Something went wrong. Try again soon or refresh your browser.",
  "asOpenData": "as open data",
  "attachment": "Attachment",
  "attachments": "Attachments",
  "backToHearingMain": "Back to hearing homepage",
  "borough": "Borough",
  "cancel": "Cancel",
  "characters": "characters",
  "clear": "Clear",
  "close": "Close",
  "closedCount": "Closed ({n})",
  "closedHearing": "Closed",
  "closeHearing": "Close hearing",
  "commentConditions": "All comments will be published {linkToDefinition} in the online service {linkToLicense}. If you are not logged in, you may leave an anonymous comment. The comments may be moderated if they contain insulting or offensive language.",
  "commentDeleted": "Your comment has been deleted.",
  "commentEdited": "Your comment has been edited. Thank you!",
  "commentFlagged": "This comment has been Flagged.",
  "commentHearingStatus": "The hearing is: ",
  "commentHelpAnswerOrCommentRequired": "Answer at least one question or write a comment.",
  "commentHelpNoPersonalInfo": "Please don't leave any personal information in your comment.",
  "commentHelpStarRequired": "Fields marked with an asterisk (*) are mandatory.",
  "commentImageAlt": "Image added by comment author",
  "commentMapAdditionalInfo": "Additional info related to the map (e.g. address)",
  "commentMapTitle": "Tag your suggestion on the map",
  "commentMapInstructions": "To tag your suggestion you must first choose a marking tool after which you can draw/tag on the map. To delete existing markings on the map you must first click the trashbin and then select 'Clear All'.",
  "commentOrder": "Order comments by:",
  "commentReceived": "Your comment has been received. Thank you!",
  "commentRegisteredUsersOnly": "Login to comment.",
  "commentReportsButtonLabel": "Reports",
  "commentReportsClose": "Close",
  "commentReportsDownload": "Download",
  "commentReportsSelectFileType": "Select a file type",
  "commentReportsTitle": "Comment reports",
  "commentVoting": "Comment voting",
  "commentOrAnswerRequiredError": "Answer at least one question or write a comment.",
  "commentRequiredError": "Write a comment before submitting.",
  "comments": "Comments",
  "sectionCommentDeletedMessage": "This message has been deleted on{date}, because it did not comply with the rules of the Voice your opinion service. https://kerrokantasi.hel.fi/info?lang=en",
  "sectionCommentGenericDeletedMessage": "This message has been deleted.",
  "sectionCommentSelfDeletedMessage": "The author deleted their own message.",
  "sectionCommentEditedMessage": "The message has been edited by the author.",
  "sectionCommentModeratedMessage": "This message has been edited because it violated the terms of use of the service. https://kerrokantasi.hel.fi/info?lang=en",
  "commentShowMap": "Map marker added. Show on the map",
  "commentsOnMap": "Comments on the map",
  "commentsOutOf": "Showing {current} comments out of {total}.",
  "commentStrongRegisteredUsersOnly": "Login with Suomi.fi-authentication to comment.",
  "commentSubsectionBtn": "Comment",
  "commentAndVoteSubsectionBtn": "Vote and write a comment",
  "contactPersons": "Contact persons",
  "contactPersonOrganizationHelpText": "If no organization is defined, your organization will be used by default.",
  "contactPersonAdditionalInfoHelpText": "Company/Entity to which the contact person belongs. Shown to users instead of the organization name, if 'External actors' has been selected as the organization",
  "contactTitle": "Job title or role description",
  "contactTitlePlaceholder": "Enter contact person's job title or role description...",
  "cookieManagementLink": "Cookie settings",
  "copyHearing": "Copy hearing",
  "copyrightHolder": "Voice your opinion (Kerrokantasi)",
  "copyrightText": "All rights reserved.",
  "create": "Create",
  "createContact": "Create a new contact",
  "CREATED_AT_ASC": "Oldest first",
  "CREATED_AT_DESC": "Newest first",
  "createHearing": "Create new hearing",
  "createLabel": "Create a new tag",
  "dataProtection": "Data Protection",
  "defaultClosureInfo": "This hearing is closed. You may no longer give comments or vote for them",
  "defaultProject": "Add new project",
  "delete": "Delete",
  "deleteAttachment": "Delete attachment",
  "deleteComment": "Delete comment",
  "deleteConfirmation": "Are your sure to delete the comment?",
  "deleteDraft": "Delete draft",
  "deleteQuestion": "Delete question",
  "deleteSection": "Delete section",
  "descriptionTag": "Voice your opinion. Join us in developing the city and participate in open hearings.",
  "disabledLink": "Disabled link",
  "downloadReport": "Download Excel report of all comments",
  "downloadFileError": "Downloading file failed",
  "draft": "Draft",
  "draftDeleted": "Draft deleted successfully",
  "draftNotPublished": "Draft, not published",
  "drafts": "Drafts",
  "draftCount": "Drafts ({n})",
  "edit": "Edit",
  "editContact": "Edit contact",
  "editHearing": "Edit",
  "email": "Email",
  "employee": "Employee",
  "errorSaveBeforeAttachment": "Save first and then return to add attachments",
  "eyeTooltip": "This hearing has not been published and is not publicly visible.",
  "eyeTooltipOpens": "This hearing will be published",
  "favoriteHearings": "Favorite hearings",
  "feedbackLinkText": "Give feedback",
  "feedbackPrompt": "Improvement ideas for Voice Your Opinion",
  "firstClosing": "Closing first",
  "follow": "Follow",
  "footerLogoAlt": "Kerrokantasi (Voice your opinion) logo",
  "formButtonAcceptAndAdd": "Accept and add",
  "formCheckErrors": "Fix form errors first",
  "fullscreenHeaderLogoAlt": "Kerrokantasi (Voice your opinion) logo",
  "generalNo": "No",
  "generalYes": "Yes",
  "headerLogoAlt": "Kerrokantasi (Voice your opinion) logo",
  "headerWriteCommentLink": "Write a comment",
  "headerOpenFrontPageLinks": "Open the Home page link menu",
  "hearing": "Hearing",
  "hearingAvailable-en": "Hearing available",
  "hearingAvailable-fi": "Kuuleminen saatavilla",
  "hearingAvailable-sv": "Hörandet tillgängligt",
  "hearingAvailableInLang-en": "in English",
  "hearingAvailableInLang-fi": "suomeksi",
  "hearingAvailableInLang-sv": "på svenska",
  "hearingArea": "If the hearing does not include the entire city, draw the exact area of the hearing on the map.",
  "hearingCardComment": "Comment",
  "hearingCardComments": "Comments",
  "hearingCardFullWidthComment": "Comment",
  "hearingCardFullWidthComments": "Comments",
  "hearingClosed": "Closed",
  "hearingClosingDate": "Closing date",
  "hearingClosingTime": "Closing time",
  "hearingClosingTimePlaceholder": "Select...",
  "hearingClosureInfo": "Closure notice",
  "hearingCommenting": "Commenting",
  "hearingCommentingMap": "Enable map marking in comments",
  "hearingCommentingMapChoice1": "Not in use",
  "hearingCommentingMapChoice2": "In use, marker marking",
  "hearingCommentingMapChoice3": "In use, marker, square and polygon marking",
  "hearingContacts": "Contacts",
  "hearingContactsPlaceholder": "Select Hearing Contacts",
  "hearingFormHeaderContainsErrors": " - contains errors",
  "hearingFormHeaderStep0": "Errors",
  "hearingFormHeaderStep1": "1. Basic information of the hearing",
  "hearingFormHeaderStep2": "2. Content",
  "hearingFormHeaderStep3": "3. Map",
  "hearingFormHeaderStep4": "4. Publishing information",
  "hearingFormHeaderStep5": "5. Project phases",
  "hearingFormNext": "Continue",
  "hearingLabels": "Keywords",
  "hearingLabelsPlaceholder": "Select appropriate keywords for the hearing",
  "hearingLanguages": "Enter hearing content",
  "hearingListComment": "Comment",
  "hearingListComments": "Comments",
  "hearingListNotPublished": "Unpublished hearing,",
  "hearingMap": "Hearings on the map",
  "hearingMapHeaderText": "Map",
  "hearingNotFound": "Hearing was not found.",
  "hearingOnlyAvailableIn": "Hearing only available",
  "hearingOnlyAvailableInLang-en": "in English",
  "hearingOnlyAvailableInLang-fi": "in Finnish",
  "hearingOnlyAvailableInLang-sv": "in Swedish",
  "hearingOpeningDate": "Opening date",
  "hearingOpeningTime": "Opening time",
  "hearingPreviewLink": "Copy preview link",
  "hearingPreviewLinkFailed": "Unable to copy preview link to clipboard.",
  "hearingPreviewLinkSuccess": "Preview link copied to clipboard.",
  "hearingPreviewLinkTooltip": "Copy preview link to clipboard.",
  "hearings": "Hearings",
  "hearingsHeaderText": "Hearings",
  "hearingSlug": "Hearing address (fill in the end part of the address)",
  "hearingSlugPlaceholder": "example address",
  "hearingSubsectionsTitle": "Subsections",
  "hearingTranslationNotAvailable": "This hearing hasn't been published in English",
  "help": "Help",
  "hideName": "Hide the name",
  "hideReplies": "Hide replies",
  "iframeAddButton": "Add iframe",
  "iframeFormFieldAllow": "Allowed additional settings (allow)",
  "iframeFormFieldHeight": "Height in pixels",
  "iframeFormFieldScrolling": "Scrolling",
  "iframeFormFieldSrc": "Source (src)",
  "iframeFormFieldTitle": "Title",
  "iframeFormFieldWidth": "Width in pixels",
  "iframeHtmlCopyPaste": "Iframe html copy paste",
  "iframeModalTitle": "Iframe information",
  "imageAddButton": "Add image",
  "imageFileUploadError": "An error occurred while uploading image.",
  "imageModalTitle": "Image information",
  "imageSizeError": "Image too big, maximum size of an image is 1MB",
  "infoHeaderText": "About the service",
  "infoPage": "About service",
  "inLanguage-en": "In English",
  "inLanguage-fi": "In Finnish",
  "inLanguage-sv": "In Swedish",
  "jumpToSearchForm": "Jump to search form",
  "jumpToSearchResults": "Jump to search results",
  "labelListTagsTitle": "Tags",
  "labelPlaceholder": "Name of tag here...",
  "lang-en": "English",
  "lang-fi": "Suomi",
  "lang-sv": "Svenska",
  "languageSwitchLabel": "Choose language",
  "lastClosing": "Closing last",
  "lastClosed": "Closed last",
  "leastCommented": "Least commented",
  "linkLeadsToExternal": "(Link leads to external service)",
  "list": "List",
  "login": "Login",
  "loginAttemptFailed": "Failed to login. Please try again in a moment.",
  "logInToAnswer": "Log in to answer and see results",
  "loginToComment": "Login to comment this hearing.",
  "loginToContinue": "Log in to continue",
  "loginToVoteComment": "Login to vote a comment.",
  "logout": "Logout",
  "mainSection": "Main section",
  "maintenanceNotificationLabel": "Maintenance",
  "maintenanceNotificationText": "The new Helsinki Profile login will be introduced 15th of May.",
  "maintenanceNotificationText2": "The Google, YLE and Facebook login methods will be removed. At the same time, employees' AD authentication will change. After the change, the Helsinki Profile service will be used for login, and users will be able to manage their own data in the city's various digital services. With the introduction of the Helsinki Profile, access to previous comments made while logged in will be disabled.",
  "maintenanceNotificationText3": "The change will also remove content production rights for employees In order to produce content. You should take the time to renew your content production rights.",
  "map": "Map",
  "mapView": "All hearings on map",
  "mostCommented": "Most commented",
  "moveDown": "Move down",
  "moveUp": "Move up",
  "multipleChoiceQuestion": "Multiple choice question (respondent can select multiple options)",
  "name": "Name",
  "nameAndOrganization": "Name and organization",
  "newestFirst": "Newest first",
  "newMultipleChoiceQuestion": "Add multiple choice question",
  "newSingleChoiceQuestion": "Add single choice question",
  "next": "Next",
  "nickname": "Nickname",
  "noAddedComments": "No comments added",
  "noCommenting": "No commenting",
  "noCommentsAvailable": "No comments",
  "noFavoriteHearings": "No favorite hearings",
  "noHearings": "Couldn't find any hearings",
  "noProject": "No project",
  "oldestFirst": "Oldest first",
  "open-hearings-on-map": "Open hearings on map",
  "openCommenting": "Open Commenting",
  "openVoting": "Open voting",
  "openCount": "Open ({n})",
  "openFullscreenMap": "Open fullscreen map",
  "openHearing": "Open",
  "openHearings": "Open hearings",
  "option": "Choice option",
  "orderHasBeenChanged": "Hearing order has been changed",
  "organization": "Organization",
  "organizationHearings": "Organization hearings",
  "ownHearings": "Own hearings",
  "partSection": "Subsection",
  "phase": "Project phases",
  "phaseActive": "Active",
  "phaseDescription": "Phase description",
  "phaseDuration": "Phase duration",
  "phone": "Phone number",
  "pinnedComment": "Pinned comment",
  "POPULARITY_ASC": "Least popular first",
  "POPULARITY_DESC": "Most popular first",
  "previous": "Previous",
  "project": "Project:",
  "projectName": "Project name",
  "projectSelection": "If the hearing belongs to a multi-phase project, select the project here.",
  "published": "Published",
  "publishedHearings": "Public",
  "publishHearing": "Approve for publishing",
  "publishHearingNow": "Publish hearing",
  "publishingQueue": "Publishing queue",
  "question": "Question",
  "questionHelpMulti": "You can choose one or more options.",
  "questionHelpSingle": "You can choose one option.",
  "questionOptionPlaceholder": "Choice option text.",
  "questionTextPlaceholder": "Write here the question you want citizens to answer.",
  "queueCount": "Publishing queue ({n})",
  "register": "Register",
  "registered": "Registered",
  "registeredStrongOnly": "Only strong identification users",
  "registeredUsersOnly": "Logged-in users only",
  "registeredUserCommentMessage": "Your name or nickname will be displayed with your comment. You can remove your name or nickname by clearing the field.",
  "removedFavorite": "Hearing removed from favorites.",
  "removeFavoriteNotFound": "Hearing not found in favorites.",
  "removeFavorites": "Remove from favorites",
  "reply": "Reply",
  "revertPublishing": "Cancel publishing",
  "save": "Save",
  "saveAndPreviewHearing": "Save and preview draft",
  "saveFailed": "Save failed",
  "saveHearingChanges": "Save changes",
  "search": "Search",
  "searchLabels": "Search labels",
  "searchPlaceholder": "Search...",
  "searchTitles": "Search from titles",
  "sectionAbstract": "Short introduction",
  "sectionAbstractPlaceholder": "Describe the main topic briefly here. Displayed at the beginning in a larger font than other text content.",
  "sectionCardSubsectionTitle": "Subsection",
  "sectionContent": "Content",
  "sectionContentPlaceholder": "The actual content, to which you can add formatting, links and images",
  "sectionImage": "Image",
  "sectionImageCaption": "Image caption",
  "sectionImageHelpText": "Recommended image size is 960 × 720 (Max. 1MB). Larger images will be scaled to the recommended size.",
  "sectionImagePlaceholder": "Explain or complete the image with a caption. Mention the name of the photographer, if necessary.",
  "sectionInformationTitle": "Information",
  "sectionTitle": "Section title",
  "sectionTitlePlaceholder": "Add a descriptive title for the section.",
  "sectionTotalComment": "{n} comment",
  "sectionTotalComments": "{n} comments",
  "selectHearingComments": "Select a hearing to show its comments",
  "selectOrDropFile": "Select or drop attachment",
  "selectOrDropImage": "Select or drop image",
  "show": "Show",
  "showAll": "Show all ({n})",
  "showMoreReplies": "Show replies",
  "showOnlyOpen": "Show only open",
  "showSubsectionBtn": "Show details",
  "singleChoiceQuestion": "Single choice question (respondent selects one option)",
  "skipLinkAddButton": "Add skip link",
  "skipLinkFormFieldHide": "Hide link",
  "skipLinkFormFieldOwnId": "Link's own id",
  "skipLinkFormFieldTargetId": "Link's target id",
  "skipLinkFormFieldText": "Link text",
  "skipLinkModalTitle": "Skip link information",
  "skipToMainContent": "Skip to main content",
  "slugInUse": "The address you selected was in use and was therefore changed.",
  "sort": "Sort",
  "scrollToTop": "Back to top",
  "submit": "Submit",
  "subsectionTitle": "Subsection",
  "timeCloseFuture": "Closes",
  "timeCloseFutureWithValues": "Closes {date} {time}",
  "timeClosePast": "Closed",
  "timeClosePastWithValues": "Closed {date} {time}",
  "timeOpenFuture": "Opens",
  "timeOpenFutureWithValues": "Opens {date} {time}",
  "timeOpenPast": "Opened",
  "timeOpenPastWithValues": "Opened {date} {time}",
  "timetable": "Timetable",
  "title": "Title",
  "titlePlaceholder": "Give a descriptive title for the hearing.",
  "toBePublishedHearing": "Hearing will be published",
  "totalNumHearing": "{n} hearing",
  "totalNumHearings": "{n} hearings",
  "totalQuestionVotes": "Total votes: {n}",
  "totalSubmittedComment": "A total of {n} comment",
  "totalSubmittedComments": "A total of {n} comments",
  "toolbar": "Toolbar",
  "tryingToDeletePhaseWithHearings": "A phase that already has hearings cannot be deleted.",
  "unpublishedAttachments": "Attachments cannot be downloaded when the hearing is not published.",
  "userInfo": "Profile",
  "userAddedComments": "My comments ({n})",
  "validationCantBeEmpty": "This field can't be empty",
  "validationHearingCloseAt": "Fill in closing time.",
  "validationHearingContactPersons": "Select at least one contact person.",
  "validationHearingLabels": "Select at least one label.",
  "validationHearingOpenAt": "Fill in opening time.",
  "validationHearingProjectPhaseActive": "Projects need at least one active phase.",
  "validationHearingProjectPhaseTitle": "Fill in the phases title.",
  "validationHearingProjectTitle": "Fill in the project's title.",
  "validationHearingSlug": "Fill in the address.",
  "validationHearingTitle": "Fill in title.",
  "validationNotification": "The form contains errors, correct the errors and try again.",
  "validationOnlyNumbers": "This field can only contain numbers",
  "vote": "Vote",
  "voteButtonLikes": "Likes",
  "voteButtonText": "Like this comment",
  "voteReceived": "Vote received. Thank you!",
  "welcome": "Voice your opinion",
  "welcomeMessage": "Join us in developing the city and participate in open hearings.",
  "withOpenLicense": "with an open license",
  "writeComment": "Comment",
  "externalContentBlocked": "Content cannot be displayed",
  "externalContentBlockedDescription": "This content is fetched from {url}. To display it, you must accept the site's cookies. You can view the content either by going to the external site or by allowing personalization and statistics cookies in the cookie settings.",
  "openExternalSite": "Go to external site",
  "editCookieSettings": "Edit cookie settings",
  "openExternalSiteAriaLabel": "Open {domain} in new window",
  "editCookieSettingsAriaLabel": "Open cookie settings to allow external content"
}
